import Router from './Router';

const App: React.FC = () => {
  return <Router />;
};

export default App;
